<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="t['dialogs-add_edit-labels']['nazvanie']"
      v-model="data.name"
      prepend-inner-icon="place"
      :placeholder="t['dialogs-add_edit-labels']['nazvanie']"
      :rules="['required', 'max100']"
    />
  </TemplateModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'WorkRegionModal',
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    create: Boolean,
    minimalize: Boolean,
  },
  data: () => ({
    dialog: false,
    data: {
      name: ''
    },
  }),
  computed: {
    ...mapGetters('workRegion', ['workRegionShow']),
    SettingWorkRegionPage() {
      return this.$route.name === 'SettingWorkRegion'
    },
    t() {
      return this.localStorage.translations.pages['setting-region']
    },
    text() {
      return {
        button: {
          open: this.minimalize
            ? this.localStorage.translations.pages['common']['buttons']['dobavit']
            : this.t['dialogs-add_edit-buttons']['dobavit-region'],
        },
        title: {
          create: this.t['dialogs-add_edit']['dobavlenie-regiona'],
          edit: this.t['dialogs-add_edit']['redaktirovanie-regiona'],
        }
      }
    },
  },
  methods: {
    ...mapActions('workRegion', [
      'onWorkRegionShow',
      'onWorkRegionCreate',
      'onWorkRegionGrid',
      'onWorkRegionUpdate',
      'onWorkRegionAll',
    ]),
    async onOpen() {
      if (!this.create) {
        await this.onWorkRegionShow(this.id)
          .then(() => {
            this.data.name = this.workRegionShow.name
            this.data.id = this.workRegionShow.id
          })
      }
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.create) {
        await this.onWorkRegionCreate(this.data)
          .then(() => {
            if (this.SettingWorkRegionPage)
              this.onWorkRegionGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
            else
              this.onWorkRegionAll()
                .then(() => {
                  this.onWorkRegionGrid({
                    limit: this.$route.query.limit,
                    page: this.$route.query.page,
                  })
                })
          })
      } else await this.onWorkRegionUpdate(this.data)
    },
  },
}
</script>
